import { Component, OnInit } from '@angular/core';
import { FieldConfig } from '../crudbuilder/models/field-config';
import { CrudBuilderConfig } from '../crudbuilder/models/crud-builder-config';

@Component({
  selector   : 'app-wizard-account',
  templateUrl: './wizard-account.component.html',
  styleUrls  : ['./wizard-account.component.scss'],
})
export class WizardAccountComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  // accountConfig: CrudBuilderConfig = {
  //   title     : 'Persoonlijke gegevens',
  //   singular  : 'Account',
  //   plural    : 'Accounts',
  //   modelAlias: 'account',
  //   path      : 'account',
  //   fields    : [
  //     new FieldConfig('name', FieldConfig.TYPE_STRING, 'Naam'),
  //     new FieldConfig('gender', FieldConfig.TYPE_GENDER, 'Geslacht'),
  //     new FieldConfig('birthday', FieldConfig.TYPE_DATE, 'Geboortedatum'),
  //     new FieldConfig('telno', FieldConfig.TYPE_PHONE, 'Telefoonnummer'),
  //     new FieldConfig('married', FieldConfig.TYPE_BOOLEAN, 'Getrouwd'),
  //     new FieldConfig('nationality', FieldConfig.TYPE_NATIONALITY, 'Nationaliteit'),
  //     new FieldConfig('bsn', FieldConfig.TYPE_NUMBER, 'BSN'),
  //   ]
  // };
  //
  // familyConfig: CrudBuilderConfig = {
  //   title: 'Gezin',
  //   fields  : [
  //     new FieldConfig('name', FieldConfig.TYPE_STRING, 'Naam Partner'),
  //     new FieldConfig('gender', FieldConfig.TYPE_GENDER, 'Geslacht'),
  //     new FieldConfig('birthday', FieldConfig.TYPE_DATE, 'Geboortedatum'),
  //     new FieldConfig('telno', FieldConfig.TYPE_PHONE, 'Telefoonnummer'),
  //     new FieldConfig('married', FieldConfig.TYPE_BOOLEAN, 'Getrouwd'),
  //     new FieldConfig('nationality', FieldConfig.TYPE_NATIONALITY, 'Nationaliteit'),
  //     new FieldConfig('bsn', FieldConfig.TYPE_NUMBER, 'BSN'),
  //   ]
  // }
  //
  // workConfig: CrudBuilderConfig = {
  //   title: 'Werk en inkomen',
  //   fields  : [
  //     new FieldConfig('position', FieldConfig.TYPE_STRING, 'Functie'),
  //     new FieldConfig('employee', FieldConfig.TYPE_STRING, 'Werknemer'),
  //     new FieldConfig('start_date', FieldConfig.TYPE_DATE, 'Start Datum'),
  //     new FieldConfig('salary', FieldConfig.TYPE_MONEY, 'Salaris'),
  //     new FieldConfig('thirteenth_month', FieldConfig.TYPE_BOOLEAN, 'Dertiende Maand'),
  //     new FieldConfig('holiday_pay', FieldConfig.TYPE_BOOLEAN, 'Vakantie Geld'),
  //     new FieldConfig('contract', FieldConfig.TYPE_CONTRACT, 'Contract'),
  //   ]
  // }
  //
  // workAndIncomeExtraConfig: CrudBuilderConfig = {
  //   title: 'Werk en inkomen extra',
  //   fields  : [
  //     new FieldConfig('name', FieldConfig.TYPE_STRING, 'Naam Partner'),
  //     new FieldConfig('gender', FieldConfig.TYPE_GENDER, 'Geslacht'),
  //     new FieldConfig('birthday', FieldConfig.TYPE_DATE, 'Geboortedatum'),
  //     new FieldConfig('telno', FieldConfig.TYPE_PHONE, 'Telefoonnummer'),
  //     new FieldConfig('married', FieldConfig.TYPE_BOOLEAN, 'Getrouwd'),
  //     new FieldConfig('nationality', FieldConfig.TYPE_NATIONALITY, 'Nationaliteit'),
  //     new FieldConfig('bsn', FieldConfig.TYPE_NUMBER, 'BSN'),
  //   ]
  // }

}
